'use client'

import { useId } from 'react'

import { createContext } from '../../utils/context.ts'
import type { TestIds } from '../../utils/testing.ts'

export type CardScale = 'sm' | 'md' | 'lg'
export type CardOrientation = 'horizontal' | 'vertical'

type UseCardProps = TestIds & {
  id?: string
  scale?: CardScale
  orientation?: CardOrientation
}

function useCard({
  id: idProp,
  dataTestId,
  dataTrackingId,
  scale,
  orientation = 'horizontal',
}: UseCardProps) {
  const uuid = useId()
  const id = idProp || uuid

  return {
    id,
    dataTestId,
    dataTrackingId,
    scale,
    orientation,
  }
}

type UseCardReturn = ReturnType<typeof useCard>

const [CardProvider, useCardContext] = createContext<UseCardReturn>({
  name: 'CardProvider',
})

export {
  CardProvider,
  type UseCardProps,
  type UseCardReturn,
  useCard,
  useCardContext,
}
